import { render, staticRenderFns } from "./OrdersList.vue?vue&type=template&id=876f1f32&scoped=true"
import script from "./OrdersList.vue?vue&type=script&lang=js"
export * from "./OrdersList.vue?vue&type=script&lang=js"
import style0 from "./OrdersList.vue?vue&type=style&index=0&id=876f1f32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876f1f32",
  null
  
)

export default component.exports